import { toDecimal } from "../../../../util/decimal-utils";
import { INLINE_ITEM_IDENTIFIER, INLINE_CATEGORY_DISPLAY_NAME, isInlineItem } from "../../../../util/common";
import _ from "lodash";
import { itemFields } from "../../../../constants/fields.constant";
import { calculateSaleAmount } from "../../../../util/calculations/sale-amount";

export const materialToForm = (_material, { qty = 1, profitMargin = 1, profitMarginType = 'PERCENTAGE' }) => {
    if (!_.isObject(_material)) _material = JSON.parse(_material);

    const item = _.cloneDeep(itemFields)
    item.name.value = _material.item;
    item.taskId.value = _material.taskId || null;
    item.id = _material.id;
    item.manufacturer = _material.manufacturer;
    item.partNo = _material.partNo || _material.part_no;
    item.categoryId = _material.categoryId;
    item.costPerItem.value = _material.cost;
    item.saleAmount.value = calculateSaleAmount({
        cost: _material.cost,
        profitMargin,
        profitMarginType,
    });
    item.saleAmountLock.value = true;
    item.unit.value = _material.unit || null;
    item.qty.value = (_material.qty * qty) || 1;
    item.total.value = toDecimal(item.saleAmount.value || 0).times(toDecimal(item.qty.value || 0)).toNumber();
    item.isInlineItem = _material.isInlineItem || isInlineItem(_material);
    item.catalog = _material.catalog || (item.isInlineItem ? INLINE_ITEM_IDENTIFIER : undefined);
    item.categoryName = _material.categoryName || (item.isInlineItem ? INLINE_CATEGORY_DISPLAY_NAME : undefined);

    return item;
}

export const updateMaterialSubTask = (subTask, templateMaterials, itemToUpdate) => {
    return subTask.material.map((material, index) => {
        const templateMaterial = templateMaterials.find(tempMaterial => tempMaterial.id === material.id);
        const templateMaterialQty = templateMaterial ? Number(templateMaterial.qty) : '';
        if (templateMaterialQty) {
            return {
                ...material,
                qty: {
                    ...material.qty,
                    value: (Number(itemToUpdate.templateQuantity) * Number(templateMaterialQty))
                },
                total: {
                    ...material.total,
                    value: (Number(itemToUpdate.templateQuantity) * Number(templateMaterialQty) * Number(material.saleAmount.value))
                }
            };
        } else return material;
    });
}

